import React from 'react';
import ReactMarkdown from 'react-markdown';
import shortcodes from './shortcodes';
import { Heading, Paragraph, Shortcode } from './markdownRenderers';
export const MarkdownCopy = props => {
  const {
    source,
    className,
    rendererClasses = {}
  } = props;
  return source ? /*#__PURE__*/React.createElement(ReactMarkdown, {
    className: className,
    escapeHtml: true,
    plugins: [shortcodes],
    renderers: {
      heading: Heading,
      paragraph: Paragraph,
      shortcode: Shortcode(rendererClasses.shortcode)
    },
    source: source
  }) : null;
};